import { useInboxNames } from '~/entities/data-sources'
import { useUserStore } from '~/entities/user'
import { useIsFeatureEnabled } from '~/shared/lib/feature-flags'
import { ExpansionPanelFilter } from '~/shared/ui'
import { useFilters } from '../../../model'
import { ClassificationFilter } from '../items/classification-filter/classification-filter'
import { DateFilter } from '../items/date-filter'
import { FlaggedFilter } from '../items/flagged-filter'
import { PayorFilter } from '../items/payor-filter/payor-filter'
import { PhaseFilter } from '../items/phase-filter'
import { ReviewerFilter } from '../items/reviewer-filter/reviewer-filter'
import { SourceFilter } from '../items/source-filter'
import { StatusFilter } from '../items/status-filter'
import { VisibilityFilter } from '../items/visibility-filter'
import { ExpansionPanelLabel } from './expansion-panel-label'

export function FiltersContent() {
  const { filters } = useFilters()
  const { data: inboxNames } = useInboxNames()
  const isOnshore = useUserStore((state) => state.isOnshore)
  const isEobEnabled = useIsFeatureEnabled('2026-02-eob-phase-1')
  const isStepFlaggingEnabled = useIsFeatureEnabled('2026-05-step-flagging')

  return (
    <>
      <ExpansionPanelFilter
        className="border-divider border-b"
        label={
          <ExpansionPanelLabel
            filterKey="status"
            label="Status"
          />
        }
        defaultExpanded
        withIndicator={filters.status.length > 0}
      >
        <StatusFilter />
      </ExpansionPanelFilter>

      <ExpansionPanelFilter
        className="border-divider border-b"
        label={
          <ExpansionPanelLabel
            filterKey="phase"
            label="Phase"
          />
        }
        defaultExpanded
        withIndicator={filters.phase.length > 0}
      >
        <PhaseFilter />
      </ExpansionPanelFilter>

      {isOnshore && (
        <ExpansionPanelFilter
          className="border-divider border-b"
          label={
            <ExpansionPanelLabel
              filterKey="visibility"
              label="Location"
            />
          }
          defaultExpanded={false}
          withIndicator={filters.visibility !== ''}
        >
          <VisibilityFilter />
        </ExpansionPanelFilter>
      )}

      {(isEobEnabled || isStepFlaggingEnabled) && (
        <ExpansionPanelFilter
          className="border-divider border-b"
          label={
            <ExpansionPanelLabel
              filterKey="flagged"
              label="Flagged Status"
            />
          }
          defaultExpanded={false}
          withIndicator={filters.flagged !== 'not_flagged'}
        >
          <FlaggedFilter />
        </ExpansionPanelFilter>
      )}

      <ExpansionPanelFilter
        className="border-divider border-b"
        label={
          <ExpansionPanelLabel
            filterKey="date"
            label="Date Received"
          />
        }
        defaultExpanded={false}
        withIndicator={!!(filters.dateFrom || filters.dateTo)}
      >
        <DateFilter />
      </ExpansionPanelFilter>

      <ExpansionPanelFilter
        className="border-divider border-b"
        label={
          <ExpansionPanelLabel
            filterKey="payor"
            label="Payor"
          />
        }
        defaultExpanded={false}
        withIndicator={!!filters.payor}
      >
        <PayorFilter />
      </ExpansionPanelFilter>

      <ExpansionPanelFilter
        className="border-divider border-b"
        label={
          <ExpansionPanelLabel
            filterKey="classification"
            label="Classification"
          />
        }
        defaultExpanded={false}
        withIndicator={!!filters.classification}
      >
        <ClassificationFilter />
      </ExpansionPanelFilter>

      <ExpansionPanelFilter
        className="border-divider border-b"
        label={
          <ExpansionPanelLabel
            filterKey="reviewer"
            label="Reviewer"
          />
        }
        defaultExpanded={false}
        withIndicator={!!filters.reviewer}
      >
        <ReviewerFilter />
      </ExpansionPanelFilter>

      {inboxNames.inbox_names.length > 0 && (
        <ExpansionPanelFilter
          label={
            <ExpansionPanelLabel
              filterKey="source"
              label="Source"
            />
          }
          defaultExpanded={false}
          withIndicator={!!filters.source}
        >
          <SourceFilter />
        </ExpansionPanelFilter>
      )}
    </>
  )
}
